import {ToMatchOptions} from 'Shared/utilities/MapDiscriminatedUnion';
import {Product} from './ProductsRiders/PlanModel';

export class UnloadedPolicyTypes {
  public readonly key = 'UnloadedPolicyTypes';
}

export class ErrorLoadingPolicyTypes {
  public readonly key = 'ErrorLoadingPolicyTypes';
}

export class LoadedPolicyTypes {
  public readonly key = 'LoadedPolicyTypes';

  constructor(public readonly availablePolicyTypes: Product[], public readonly selectedPolicyTypes: Product[]) {}
}

export type PolicyTypes = LoadedPolicyTypes | UnloadedPolicyTypes | ErrorLoadingPolicyTypes;

export type PolicyTypesOptions<TReturn> = ToMatchOptions<PolicyTypes, 'key', TReturn>;

export const matchPolicyTypes = <TReturn>(policyTypes: PolicyTypes, options: PolicyTypesOptions<TReturn>): TReturn => {
  switch (policyTypes.key) {
    case 'UnloadedPolicyTypes':
      return options.UnloadedPolicyTypes(policyTypes);
    case 'ErrorLoadingPolicyTypes':
      return options.ErrorLoadingPolicyTypes(policyTypes);
    case 'LoadedPolicyTypes':
      return options.LoadedPolicyTypes(policyTypes);
  }
};

export const isLoadedPolicyTypes = (policyTypes: PolicyTypes): policyTypes is LoadedPolicyTypes =>
  policyTypes.key === 'LoadedPolicyTypes';

export const isUnloadedPolicyTypes = (policyTypes: PolicyTypes): policyTypes is UnloadedPolicyTypes =>
  policyTypes.key === 'UnloadedPolicyTypes';

export const isErrorLoadingPolicyTypes = (policyTypes: PolicyTypes): policyTypes is ErrorLoadingPolicyTypes =>
  policyTypes.key === 'ErrorLoadingPolicyTypes';

export const EmptyPolicyTypes = new UnloadedPolicyTypes();
